module.exports = __webpack_public_path__ + "static/media/level_3.f95297ba.svg";